module.exports = __webpack_public_path__ + "img/78a9ebd.jpg";